// import Dashboard from "./layouts/Dashboard/Dashboard.jsx";
import Dashboard from "../layouts/Dashboard/Dashboard";

var indexRoutes = [{ path: "/", name: "Home", component: Dashboard }];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx